<div class="previews-wrap">
    <div class="previews" [class.previews_4-columns]="columns === 4">
        <pdf-viewer 
            [src]="src"
            [show-all]="true"
            [original-size]="false"
            [show-borders]="true"
            [autoresize]="true"
            [render-text]="false"
            [zoom]="1/columns - 0.01"
            class="previews-pages__page"
            (page-rendered)="pageRendered()"
            (after-load-complete)="onLoadComplete($event)"
            (click)="pageChanged($event)"
        ></pdf-viewer>
    </div>
</div>